<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'common.work_machine'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('goto-list')"
  >
  </RightInfoPanelGeneric>
</template>

<script>
import RightInfoPanelGeneric from '@/components/Common/RightInfoPanelGeneric.vue';

export default {
  name: 'WorkMachineRightPanel',
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return [
        {
          labelKey: 'common.unit',
          path: 'department.name',
          required: true,
        },
        {
          labelKey: 'common.name',
          path: 'name',
          required: true,
        },
        {
          labelKey: 'works.work_machines.registration_number_short',
          path: 'registration_number',
          required: true,
        },
      ];
    },
  },
};
</script>
 
